import styled from "@emotion/styled";
import { black } from "../../assets/styles/colors";
import { mq } from "../../assets/styles/mediaqueries";

export const profileContainerStyle = {
  marginTop: 25,

  [mq[2]]: {
    marginTop: 50,
  },
};

export const profileButtonsStyle = {
  display: "flex",
  justifyContent: "space-between",

  "@media only print": {
    display: "none",
  },
};

export const StyledProfileDetailsContainer = styled.div(({ imgPosition }) => ({
  display: "flex",
  flexFlow: "wrap",
  marginTop: 50,
  marginBottom: 100,

  "@media only print": {
    flexDirection: "column-reverse",
  },

  "> div:first-of-type": {
    maxWidth: "none !important",
    width: "100%",

    [mq[2]]: {
      maxWidth: "none !important",
    },
  },

  "> span:first-of-type": {
    width: "100% !important",

    [mq[2]]: {
      width: "initial !important",
    },
  },

  [mq[1]]: {
    "> *": {
      flexBasis: "50%",
    },
  },

  img: {
    objectPosition: imgPosition?.toLowerCase() + " !important",

    "@media print": {
      maxWidth: 200 + "px !important",
      minWidth: "unset !important",
      width: 200 + "px !important",
    },
  },
}));

export const profileDetailStyle = {
  marginTop: 50,
  width: "100%",

  h2: {
    fontSize: "1.25rem",
    margin: 0,
    flexBasis: "35%",

    [mq[1]]: {
      flexBasis: "40%",
    },
    [mq[2]]: {
      flexBasis: "46%",
      fontSize: "1.5625rem",
    },
    [mq[3]]: {
      flexBasis: "auto",
      width: 130,
    },
  },

  "> div": {
    marginBottom: 25,
    display: "flex",
    alignItems: "center",
    flexFlow: "wrap",
    justifyContent: "space-between",
    p: {
      margin: 0,
    },
    "& ul, & p": {
      flexBasis: "65%",
      [mq[1]]: {
        flexBasis: "100%",
      },
      [mq[2]]: {
        flexBasis: "54%",
      },
    },
  },

  [mq[1]]: {
    marginTop: 0,
    paddingLeft: 50,
    flexBasis: "50%",
  },
  [mq[3]]: {
    paddingLeft: 100,
  },
};

export const profileTitleStyle = {
  borderBottom: `1px solid ${black}`,
  paddingBottom: 10,
  marginBottom: 25,
  fontSize: "2.5rem",

  [mq[1]]: {
    marginBottom: 50,
  },
};

export const profileEnumListStyle = {
  display: "flex",
  color: `${black}50`,

  li: {
    marginRight: 25,

    ":last-of-type": {
      marginRight: 0,
    },
  },
};

export const StyledBigImgContainer = styled.div(({ isOpen }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: `${black}75`,
  transform: isOpen ? "scale(1)" : "scale(0)",
  opacity: isOpen ? 1 : 0,
  transition: "opacity .3s ease",
  zIndex: 99,
}));

export const bigImgStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "50%",
  maxHeight: "90%",
  objectFit: "contain",

  "@media only print": {
    maxWidth: 100,
  },
};
